module.exports = __webpack_public_path__ + "static/media/material_quality-min.676623e2.jpg";